const isAuthType = async (to,from,next) =>{
    if(localStorage.getItem('apiKey') != null){
        next()
    }
    else next ('/login')
}
export default isAuthType